import { TextField } from "@mui/material";
import { UseFormRegisterReturn } from "react-hook-form";

export const CustomInput = ({
	registration: { name, onChange, onBlur, ref },
	error,
	disabled,
}: {
	registration: UseFormRegisterReturn;
	error: boolean;
	disabled: boolean;
}) => (
	<TextField
		name={name}
		onChange={onChange}
		onBlur={onBlur}
		inputRef={ref}
		error={error}
		variant="outlined"
		size="small"
		disabled={disabled}
		autoComplete="off"
		sx={{
			width: "70%",
			backgroundColor: (theme) => theme.palette.background.paper,
		}}
		inputProps={{ style: { fontSize: 11, padding: "5px 8px" } }}
	/>
);
